import { render, staticRenderFns } from "./ProductFiltersTab.vue?vue&type=template&id=651cf102&"
import script from "./ProductFiltersTab.vue?vue&type=script&lang=js&"
export * from "./ProductFiltersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports